import { type ProductForHotelFilters } from '@ve/components/hotel/filters/common/store/types';
import { OperatorId } from '@entities/operator';
import { type ITourProduct } from '@entities/tourProduct';

export const MIR_CASHBACK_OPERATORS = new Set(OperatorId.Travelata);

export const MIR_CASHBACK_TEXT = 'Кешбэк 5% по карте МИР';

export const MIR_CASHBACK_INFO = {
    description: 'При покупке тура картой МИР возможно начисление кешбэка.',
    availability: 'Данная опция доступна только при выборе туроператора Travelata.',
};

export const filterByMirCashback = (tourProduct: ITourProduct | ProductForHotelFilters): boolean =>
    !!tourProduct?.operator && MIR_CASHBACK_OPERATORS.has(tourProduct.operator?.id);

export const hasNonMirCashbackOperators = (selectedOperators?: number[]): boolean => {
    if (!selectedOperators || selectedOperators.length === 0) {
        return false;
    }
    return selectedOperators.some((operatorId) => !MIR_CASHBACK_OPERATORS.has(operatorId));
};
